module.exports = __webpack_public_path__ + "static/img/03-02.0cf840b0.png";